export const SET_POSITIONS = "SET_POSITIONS";